var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_2647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 17.34C26 16.65 25.47 16.08 24.8 16.01H24.66H17.34C16.6 16.01 16 16.61 16 17.35V24.67C16 25.41 16.6 26.01 17.34 26.01H24.66C25.4 26.01 26 25.41 26 24.67V17.34ZM27 24.66C27 25.95 25.95 27 24.66 27H17.34C16.05 27 15 25.95 15 24.66V17.34C15 16.05 16.05 15 17.34 15H24.9C26.08 15.13 27 16.13 27 17.34V24.66Z",
    fill: "#5F6774"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 21C23 20.46 22.79 19.96 22.41 19.59C22.03 19.21 21.53 19 21 19C20.47 19 19.96 19.21 19.59 19.59C19.21 19.97 19 20.47 19 21C19 21.53 19.21 22.04 19.59 22.41C19.97 22.79 20.47 23 21 23C21.53 23 22.03 22.79 22.41 22.41C22.79 22.03 23 21.53 23 21ZM24 21C24 21.8 23.69 22.56 23.12 23.12C22.55 23.69 21.8 24 21 24C20.2 24 19.44 23.69 18.88 23.12C18.31 22.55 18 21.8 18 21C18 20.2 18.31 19.44 18.88 18.88C19.45 18.31 20.2 18 21 18C21.8 18 22.56 18.31 23.12 18.88C23.69 19.45 24 20.2 24 21Z",
    fill: "#5F6774"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 18C23 17.45 23.45 17 24 17C24.55 17 25 17.45 25 18C25 18.55 24.55 19 24 19C23.45 19 23 18.55 23 18Z",
    fill: "#5F6774"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_2647"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.e23b1ecf0e1ed866e58b2ffc0e13f0e9.svg";
export { ForwardRef as ReactComponent };